import styled, { css } from "styled-components";
import { Link } from "@viagogo/core/ui";

const handleOverlayResolution = ({
  $renderSimpleOverlay,
  $backgroundImageSet,
  $backgroundImageUrl,
  $isStubhub,
}: {
  $renderSimpleOverlay?: boolean;
  $backgroundImageSet?: Record<string, string>;
  $backgroundImageUrl: string;
  $isStubhub?: boolean;
}) => {
  if ($renderSimpleOverlay && $backgroundImageSet) {
    const backgroundEntries = Object.entries($backgroundImageSet).map(([res, url]) => `url("${url}") ${res}`);
    const background = `image-set(${backgroundEntries.join(", ")})`;
    return css`
      background: ${background};
      filter: brightness(70%);
    `;
  }
  return css`
    background: ${`url(${$backgroundImageUrl}) ${$isStubhub ? "#873CFF" : "#87AE44"}`};
    background-blend-mode: multiply;
  `;
};

const handleOverlayResolutionNoOverlay = (props: { $backgroundImageUrl: string }) => css`
  background: url(${props.$backgroundImageUrl}) no-repeat center center;
  background-size: cover;
  filter: brightness(70%);
`;

export const StyledTopSubcategoryCard = styled.li<{ size: { height: string } }>`
  border-radius: ${(props) => props.theme.borderRadius.xl};
  height: ${(props) => props.size.height}px;
  padding: ${(props) => props.theme.spacing(2)};
`;

export const StyledLink = styled(Link)`
  border-radius: ${(props) => props.theme.borderRadius.xl};
  display: block;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const StyledBackgroundImage = styled.div<{
  $renderSimpleOverlay?: boolean;
  $backgroundImageSet?: Record<string, string>;
  $backgroundImageUrl: string;
  $isStubhub?: boolean;
}>`
  ${handleOverlayResolution};
  background-size: cover;
  height: 100%;
  width: 100%;
`;

export const StyledBackgroundImageNoOverlay = styled.div<{ $backgroundImageUrl: string }>`
  ${handleOverlayResolutionNoOverlay};
  height: 100%;
  width: 100%;
`;

export const StyledCategoryName = styled.p`
  ${({
    theme: {
      typography: { fontWeight, getStyles, variant },
    },
  }) => getStyles(variant.body1, fontWeight.bold)};
  color: ${(props) => props.theme.colors.textInverted};
  width: max-content;
  position: absolute;
  bottom: 16px;
  left: 16px;
`;
